import ReactMarkdown from "react-markdown"
import tw from "twin.macro"
import Image from "next/image"
import { BodyText } from "../bodyText"
import Link from "next/link"
import { ContentDataProps } from "../../pages/[parent]"
import { Attachment } from "airtable"

interface CardProps {
  details: string
  body: string
  image_url: string
  image_preview: Array<Attachment>
  caption: string
  link: string
  media_size: string
}

const Card = (props: CardProps) => {
  const { body, details, image_url, image_preview, caption, link, media_size } = props
  const bodyText = body && body != "" ? body.toString() : ""

  const thisImage =
    image_preview && image_preview[0] && image_preview[0].thumbnails && image_preview[0].thumbnails.large
  const width = thisImage && thisImage.width
  const height = thisImage && thisImage.height

  const altText = caption
    ? `${caption.toString()} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  return (
    <div tw="grid grid-cols-4 tablet:(grid-cols-12) gap-4 tablet:(gap-6)">
      {image_url && (
        <div tw="col-span-4 tablet:col-span-3">
          {link && (
            <Link href={link.toString()} passHref target="_new>">
              <Image
                key={image_preview[0].id}
                src={image_url}
                width={width}
                height={height}
                alt={altText}
                priority={true}
              />
            </Link>
          )}
        </div>
      )}
      <div tw="col-span-4 tablet:col-span-9">
        <div tw="space-y-1">
          <h3 tw="text-sm text-rpd-blue font-black font-sans uppercase">
            {link && (
              <Link href={link.toString()} passHref target="_new>">
                {details}
              </Link>
            )}
          </h3>

          <BodyText>
            <ReactMarkdown tw="text-sm font-sans">{bodyText}</ReactMarkdown>
          </BodyText>

          {link && (
            <p tw="text-rpd-green uppercase font-sans font-bold">
              <Link
                href={link.toString()}
                passHref
                tw="font-bold text-sm text-rpd-green uppercase font-sans"
                target="_new>"
              >
                {`Download ${media_size ? media_size : ""} PDF`}
              </Link>
              {` `}»
            </p>
          )}
        </div>
      </div>
    </div>
  )
  return <></>
}

const NathanielPeriodicals = (props: ContentDataProps) => {
  const { contentData } = props

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <div tw="col-span-4 tablet-lg:col-span-12">
          <div tw="space-y-12">
            {contentData.map((item: any, i: number) => {
              return <Card {...item.fields} key={i} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NathanielPeriodicals
